/**
 * Is image source
 */
export function isSrc(url) {
  return /^(https?:)?\/\/|data:image/.test(url);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vant@1.6.17@vant/es/utils/validate/src.js
// module id = null
// module chunks = 